// Central content, contact info, imagery and bilingual copy for
// Angel Cars Upholstery Service. Images are high-quality placeholders and
// can be swapped for the client's real Instagram photos.

const U = "https://images.unsplash.com";
export const img = (id, w = 1400) =>
  `${U}/${id}?crop=entropy&cs=srgb&fm=jpg&q=80&w=${w}`;

export const CONTACT = {
  name: "Angel Cars Upholstery Service",
  owner: "Ángel Robles",
  email: "angelcarsuphosltery@gmail.com",
  phone1: "786-339-3368",
  phone2: "786-227-2913",
  phone1Raw: "17863393368",
  phone2Raw: "17862272913",
  whatsapp: "17863393368",
  instagram: "https://www.instagram.com/angelcarsupholstery?igsh=ZW8wOTZodzdtbXI1",
  instagramHandle: "@angelcarsupholstery",
  logo: "https://customer-assets.emergentagent.com/job_374de249-71bb-4257-bef4-9e3e6e08f0fb/artifacts/sa1ygjla_3_20260706_164047_0002.png",
};

export const waLink = (msg) =>
  `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(msg)}`;

const REAL = "https://customer-assets.emergentagent.com/job_premium-interiors-107/artifacts";
export const REAL_PHOTOS = {
  beforeCar: `${REAL}/qs1cpzan_Screenshot_20260706_171914_Instagram.jpg`,
  afterCar: `${REAL}/ze251zbr_Screenshot_20260706_171934_Instagram.jpg`,
  beforePanel: `${REAL}/cmtr10c6_Screenshot_20260706_171955_Instagram.jpg`,
  afterPanel: `${REAL}/y8gzzdif_Screenshot_20260706_172004_Instagram.jpg`,
  beforePanel2: `${REAL}/js8oyih7_Screenshot_20260706_172017_Instagram.webp`,
  angel: `${REAL}/bjqdl9go_file_0000000062d8722f8ce4a13f0307538f.png`,
};

export const IMAGES = {
  hero: img("photo-1768024175212-98eb7cd5ca46", 1920),
  about: REAL_PHOTOS.angel,
  aboutDetail: REAL_PHOTOS.beforeCar,
  academy: img("photo-1496180317060-d2026272f138", 1400),
  services: {
    headliner: REAL_PHOTOS.afterCar,
    sunroof: img("photo-1661993745460-c16e6a83b718", 1000),
    doors: img("photo-1772555429170-be39986f4d99", 1000),
    pillars: img("photo-1753838939619-0d3db4f3bddb", 1000),
    detailing: img("photo-1732357624591-f2137085659b", 1000),
  },
  beforeAfter: [
    { before: REAL_PHOTOS.beforeCar, after: REAL_PHOTOS.afterCar },
    { before: REAL_PHOTOS.beforePanel, after: REAL_PHOTOS.afterPanel },
  ],
  gallery: [
    { src: REAL_PHOTOS.afterCar, cat: "headliner" },
    { src: REAL_PHOTOS.afterPanel, cat: "headliner" },
    { src: img("photo-1768024175212-98eb7cd5ca46", 900), cat: "headliner" },
    { src: img("photo-1661993745460-c16e6a83b718", 900), cat: "sunroof" },
    { src: img("photo-1772555429170-be39986f4d99", 900), cat: "doors" },
    { src: REAL_PHOTOS.beforePanel2, cat: "headliner" },
    { src: img("photo-1591388156010-dd522151da35", 900), cat: "sunroof" },
    { src: REAL_PHOTOS.beforeCar, cat: "headliner" },
  ],
};

export const TRANSLATIONS = {
  es: {
    langLabel: "EN",
    nav: {
      home: "Inicio",
      services: "Servicios",
      about: "Nosotros",
      gallery: "Galería",
      why: "Por qué elegirnos",
      testimonials: "Testimonios",
      faq: "FAQ",
      contact: "Contacto",
      quote: "Solicitar Cotización",
    },
    hero: {
      badge: "Servicio a Domicilio",
      title1: "Restauramos el interior de tu vehículo",
      title2: "como si fuera nuevo",
      subtitle:
        "Especialistas en restauración de techos, sunroof, puertas, columnas y detailing profesional. Servicio a domicilio en Miami-Dade y Broward.",
      cta1: "Solicitar Cotización",
      cta2: "Llámanos Ahora",
      stat1: "Años de experiencia",
      stat2: "Vehículos restaurados",
      stat3: "Valoración de clientes",
      area: "Servicio en Miami-Dade · Broward",
    },
    services: {
      kicker: "Lo que hacemos",
      title: "Nuestros Servicios",
      subtitle:
        "Acabados de alta calidad, materiales premium y atención personalizada en cada trabajo.",
      items: [
        {
          key: "headliner",
          title: "Restauración de Techos (Headliner)",
          points: [
            "Reemplazo completo del techo interior",
            "Corrección de tela caída",
            "Materiales de excelente calidad",
            "Acabados similares a los originales de fábrica",
          ],
        },
        {
          key: "sunroof",
          title: "Reparación de Sunroof",
          points: [
            "Restauración del revestimiento interior del sunroof",
            "Acabados limpios y profesionales",
          ],
        },
        {
          key: "doors",
          title: "Tapicería de Puertas",
          points: [
            "Reemplazo de tela y materiales deteriorados",
            "Restauración completa de paneles interiores",
          ],
        },
        {
          key: "pillars",
          title: "Restauración de Columnas",
          points: [
            "Tapizado de pilares interiores",
            "Perfecta combinación de colores y texturas",
          ],
        },
        {
          key: "detailing",
          title: "Auto Detailing",
          points: [
            "Limpieza profunda del interior",
            "Limpieza exterior",
            "Protección y acabado premium",
          ],
        },
      ],
      cta: "Solicitar Cotización",
    },
    estimator: {
      kicker: "Cotización instantánea",
      title: "Calcula el precio de tu techo",
      subtitle:
        "Elige el tipo de vehículo y obtén un estimado al instante para el cambio de techo (headliner).",
      modelLabel: "Modelo del vehículo",
      modelPlaceholder: "Ej. Toyota Camry",
      yearLabel: "Año",
      yearPlaceholder: "Ej. 2018",
      typeLabel: "Tipo de vehículo",
      typePlaceholder: "Selecciona un tipo",
      sunroofLabel: "¿Tu sunroof necesita tapizarse?",
      yes: "Sí",
      no: "No",
      resultLabel: "Precio estimado",
      completeHint:
        "Completa el tipo de vehículo y la opción de sunroof para ver tu estimado.",
      disclaimer:
        "Estimado referencial para el cambio de techo (headliner). El precio final puede variar según el modelo y estado del vehículo, si desea material Suede o Alcantara, y la distancia de la dirección, ya que el precio mostrado corresponde a zona central. El precio con sunroof aplica solo si el forro del sunroof también se necesita tapizar. Se solicita foto para hacer match de color. Los colores especiales (diferentes de negro, gris o beige) requieren abonar el 50% antes del trabajo.",
      cta: "Enviar por WhatsApp",
      types: [
        { key: "sedan", label: "Sedán", examples: "Camry, Accord, Corolla", noSun: 180, withSun: 250 },
        { key: "suv_s", label: "SUV pequeño", examples: "Equinox, Honda CR-V", noSun: 250, withSun: 350 },
        { key: "suv_m", label: "SUV mediano", examples: "Tahoe, Porsche Cayenne", noSun: 280, withSun: 380 },
        { key: "suv_l", label: "SUV grande", examples: "Suburban, Expedition, Excursion", noSun: 400, withSun: 480 },
      ],
      waTemplate: (o) =>
        `Hola Angel Cars, quiero cotizar el cambio de techo de mi ${o.type}${o.model ? " " + o.model : ""}${o.year ? " " + o.year : ""}. Sunroof a tapizar: ${o.sunroof}. Precio estimado: $${o.price}. ¿Me confirman disponibilidad?`,
    },
    about: {
      kicker: "Sobre Nosotros",
      title: "Ángel Robles, pasión por el detalle",
      p1: "Angel Cars Upholstery Service nació de la obsesión de Ángel Robles por un solo objetivo: devolverle a cada vehículo la sensación de estrenarlo. Durante más de ocho años ha restaurado interiores de decenas de marcas, aprendiendo que la diferencia entre un buen trabajo y uno impecable está en los milímetros.",
      p2: "Cada techo, cada columna y cada panel se trata como si fuera su propio auto. Ángel selecciona personalmente los materiales, cuida la combinación exacta de colores y texturas, y no entrega un vehículo hasta que el acabado luce como el original de fábrica.",
      p3: "Trabajamos a domicilio, llegando directamente hasta ti en Miami-Dade y Broward, con la seriedad, la transparencia y la atención personalizada que mereces.",
      tags: ["+8 años de experiencia", "Servicio a domicilio", "Trabajo garantizado"],
    },
    gallery: {
      kicker: "Trabajos reales",
      title: "Galería · Antes y Después",
      subtitle:
        "Desliza para ver la transformación. Techos, sunroof, puertas, columnas, detailing e interiores completos.",
      before: "Antes",
      after: "Después",
      followCta: "Ver más en Instagram",
      cats: {
        interior: "Interior",
        headliner: "Techos",
        doors: "Puertas",
        sunroof: "Sunroof",
        detailing: "Detailing",
        pillars: "Columnas",
      },
    },
    why: {
      kicker: "Por qué elegirnos",
      title: "La diferencia de un verdadero especialista",
      items: [
        { icon: "Award", title: "+8 años de experiencia", desc: "Trayectoria comprobada restaurando interiores." },
        { icon: "Car", title: "Especialistas en interiores", desc: "100% enfocados en tapicería automotriz." },
        { icon: "Gem", title: "Materiales de alta calidad", desc: "Telas y materiales premium seleccionados." },
        { icon: "Heart", title: "Excelente servicio", desc: "Atención cercana y honesta de principio a fin." },
        { icon: "ShieldCheck", title: "Trabajo garantizado", desc: "Respaldamos cada acabado que entregamos." },
        { icon: "Sparkles", title: "Resultados profesionales", desc: "Acabados similares a los de fábrica." },
        { icon: "Zap", title: "Cotización rápida", desc: "Respuesta ágil por WhatsApp con tus fotos." },
        { icon: "UserCheck", title: "Atención personalizada", desc: "Cada proyecto tratado como único." },
      ],
    },
    how: {
      kicker: "Cómo trabajamos",
      title: "Un proceso simple y transparente",
      steps: [
        { title: "Contáctanos", desc: "Escríbenos por WhatsApp o llámanos." },
        { title: "Envíanos fotos", desc: "Comparte fotografías de tu vehículo." },
        { title: "Recibe tu cotización", desc: "Te damos un presupuesto personalizado." },
        { title: "Agenda tu cita", desc: "Coordinamos día y hora, vamos hasta ti." },
        { title: "Disfruta el resultado", desc: "Recibe tu vehículo completamente renovado." },
      ],
    },
    testimonials: {
      kicker: "Testimonios",
      title: "Clientes que confiaron en nosotros",
      items: [
        { name: "Carlos M.", role: "Miami, FL", text: "El techo de mi SUV estaba completamente caído. Ángel lo dejó como nuevo y vino hasta mi casa. Trabajo impecable." },
        { name: "Jennifer R.", role: "Hialeah, FL", text: "Súper profesional y detallista. La tapicería de mis puertas quedó idéntica a la original. 100% recomendado." },
        { name: "David S.", role: "Fort Lauderdale, FL", text: "Rápido para cotizar y puntual. El detailing interior dejó mi auto oliendo y luciendo como recién salido de agencia." },
        { name: "María G.", role: "Doral, FL", text: "La restauración de las columnas y el sunroof superó mis expectativas. Excelente atención de principio a fin." },
      ],
    },
    faq: {
      kicker: "Preguntas frecuentes",
      title: "Resolvemos tus dudas",
      items: [
        { q: "¿Qué marcas trabajan?", a: "Trabajamos interiores de prácticamente todas las marcas y modelos, desde autos de uso diario hasta vehículos de alta gama." },
        { q: "¿Cuánto tarda el trabajo?", a: "Depende del modelo del vehículo: el trabajo toma aproximadamente de 2 a 4 horas. Se asigna día y hora sujeto a disponibilidad de agenda, coordinando por WhatsApp." },
        { q: "¿Tiene garantía?", a: "Sí. Ofrecemos garantía de 30 días después de la reparación sobre nuestro trabajo y materiales." },
        { q: "¿Debo dejar el vehículo?", a: "En la mayoría de los casos no. Somos un servicio a domicilio: vamos hasta ti en Miami-Dade y Broward." },
        { q: "¿Cómo solicito una cotización?", a: "Muy fácil: escríbenos por WhatsApp con fotos de tu vehículo y te enviamos un presupuesto personalizado." },
      ],
    },
    academy: {
      badge: "Próximamente",
      title: "Angel Cars Academy",
      text: "Muy pronto compartiremos nuestra experiencia a través de cursos especializados en tapicería automotriz para quienes deseen aprender este oficio y desarrollar su propio negocio.",
      placeholder: "Tu correo electrónico",
      button: "Quiero recibir información sobre los cursos",
      success: "¡Listo! Te avisaremos cuando abramos inscripciones.",
      error: "Ingresa un correo válido, por favor.",
    },
    contact: {
      kicker: "Contacto",
      title: "Solicita tu cotización hoy",
      subtitle:
        "Estamos listos para restaurar el interior de tu vehículo. Escríbenos y recibe una respuesta rápida.",
      location: "Florida, Estados Unidos",
      areaLabel: "Área de servicio",
      areas: "Miami-Dade County · Broward County",
      emailLabel: "Correo",
      phoneLabel: "Teléfonos",
      whatsapp: "WhatsApp",
      call: "Llamar",
      quote: "Solicitar Cotización",
      whatsappMsg:
        "Hola Angel Cars, me gustaría solicitar una cotización para la restauración del interior de mi vehículo.",
    },
    footer: {
      tagline:
        "Especialistas en restauración de interiores de vehículos con acabados de alta calidad en Miami-Dade y Broward.",
      quickLinks: "Enlaces rápidos",
      contact: "Contacto",
      follow: "Síguenos",
      rights: "Todos los derechos reservados.",
    },
  },

  en: {
    langLabel: "ES",
    nav: {
      home: "Home",
      services: "Services",
      about: "About",
      gallery: "Gallery",
      why: "Why Us",
      testimonials: "Reviews",
      faq: "FAQ",
      contact: "Contact",
      quote: "Request a Quote",
    },
    hero: {
      badge: "Mobile Service · We Come to You",
      title1: "We restore your vehicle's interior",
      title2: "like it's brand new",
      subtitle:
        "Specialists in headliner, sunroof, door, pillar restoration and professional detailing. Mobile service across Miami-Dade and Broward.",
      cta1: "Request a Quote",
      cta2: "Call Us Now",
      stat1: "Years of experience",
      stat2: "Vehicles restored",
      stat3: "Customer rating",
      area: "Serving Miami-Dade · Broward",
    },
    services: {
      kicker: "What we do",
      title: "Our Services",
      subtitle:
        "High-quality finishes, premium materials and personalized attention on every job.",
      items: [
        {
          key: "headliner",
          title: "Headliner Restoration",
          points: [
            "Full interior roof replacement",
            "Sagging fabric correction",
            "Excellent quality materials",
            "Factory-like finishes",
          ],
        },
        {
          key: "sunroof",
          title: "Sunroof Repair",
          points: [
            "Sunroof interior lining restoration",
            "Clean, professional finishes",
          ],
        },
        {
          key: "doors",
          title: "Door Upholstery",
          points: [
            "Replacement of worn fabric and materials",
            "Complete interior panel restoration",
          ],
        },
        {
          key: "pillars",
          title: "Pillar Restoration",
          points: [
            "Interior pillar re-upholstery",
            "Perfect color and texture matching",
          ],
        },
        {
          key: "detailing",
          title: "Auto Detailing",
          points: [
            "Deep interior cleaning",
            "Exterior cleaning",
            "Protection and premium finish",
          ],
        },
      ],
      cta: "Request a Quote",
    },
    estimator: {
      kicker: "Instant quote",
      title: "Calculate your headliner price",
      subtitle:
        "Pick your vehicle type and get an instant estimate for the headliner replacement.",
      modelLabel: "Vehicle model",
      modelPlaceholder: "e.g. Toyota Camry",
      yearLabel: "Year",
      yearPlaceholder: "e.g. 2018",
      typeLabel: "Vehicle type",
      typePlaceholder: "Select a type",
      sunroofLabel: "Does your sunroof need re-upholstery?",
      yes: "Yes",
      no: "No",
      resultLabel: "Estimated price",
      completeHint:
        "Select the vehicle type and sunroof option to see your estimate.",
      disclaimer:
        "Reference estimate for the headliner replacement. The final price may vary by model and vehicle condition, if you choose Suede or Alcantara material, and by the distance to your address, since the price shown is for the central zone. The 'with sunroof' price applies only if the sunroof lining also needs re-upholstery. A photo is requested to color-match. Special colors (other than black, gray or beige) require a 50% deposit before the work.",
      cta: "Send via WhatsApp",
      types: [
        { key: "sedan", label: "Sedan", examples: "Camry, Accord, Corolla", noSun: 180, withSun: 250 },
        { key: "suv_s", label: "Small SUV", examples: "Equinox, Honda CR-V", noSun: 250, withSun: 350 },
        { key: "suv_m", label: "Mid-size SUV", examples: "Tahoe, Porsche Cayenne", noSun: 280, withSun: 380 },
        { key: "suv_l", label: "Large SUV", examples: "Suburban, Expedition, Excursion", noSun: 400, withSun: 480 },
      ],
      waTemplate: (o) =>
        `Hi Angel Cars, I'd like a quote for the headliner replacement of my ${o.type}${o.model ? " " + o.model : ""}${o.year ? " " + o.year : ""}. Sunroof to re-upholster: ${o.sunroof}. Estimated price: $${o.price}. Can you confirm availability?`,
    },
    about: {
      kicker: "About Us",
      title: "Ángel Robles, passion for detail",
      p1: "Angel Cars Upholstery Service was born from Ángel Robles' obsession with a single goal: to give every vehicle back that brand-new feeling. For over eight years he has restored interiors across dozens of brands, learning that the difference between good work and flawless work lives in the millimeters.",
      p2: "Every headliner, pillar and panel is treated as if it were his own car. Ángel personally selects the materials, matches colors and textures precisely, and never hands back a vehicle until the finish looks factory-original.",
      p3: "We work Mobile, coming directly to you across Miami-Dade and Broward, with the seriousness, transparency and personalized attention you deserve.",
      tags: ["+8 years experience", "Mobile service", "Guaranteed work"],
    },
    gallery: {
      kicker: "Real work",
      title: "Gallery · Before & After",
      subtitle:
        "Drag to reveal the transformation. Headliners, sunroof, doors, pillars, detailing and full interiors.",
      before: "Before",
      after: "After",
      followCta: "See more on Instagram",
      cats: {
        interior: "Interior",
        headliner: "Headliner",
        doors: "Doors",
        sunroof: "Sunroof",
        detailing: "Detailing",
        pillars: "Pillars",
      },
    },
    why: {
      kicker: "Why choose us",
      title: "The difference of a true specialist",
      items: [
        { icon: "Award", title: "+8 years experience", desc: "A proven track record restoring interiors." },
        { icon: "Car", title: "Interior specialists", desc: "100% focused on auto upholstery." },
        { icon: "Gem", title: "High-quality materials", desc: "Premium hand-picked fabrics and materials." },
        { icon: "Heart", title: "Excellent service", desc: "Honest, close attention from start to finish." },
        { icon: "ShieldCheck", title: "Guaranteed work", desc: "We stand behind every finish we deliver." },
        { icon: "Sparkles", title: "Professional results", desc: "Factory-like finishes every time." },
        { icon: "Zap", title: "Fast quotes", desc: "Quick WhatsApp response with your photos." },
        { icon: "UserCheck", title: "Personalized care", desc: "Every project treated as unique." },
      ],
    },
    how: {
      kicker: "How we work",
      title: "A simple, transparent process",
      steps: [
        { title: "Contact us", desc: "Message us on WhatsApp or give us a call." },
        { title: "Send us photos", desc: "Share pictures of your vehicle." },
        { title: "Get your quote", desc: "We send a personalized estimate." },
        { title: "Book your appointment", desc: "We schedule and come to you." },
        { title: "Enjoy the result", desc: "Receive your fully renewed vehicle." },
      ],
    },
    testimonials: {
      kicker: "Reviews",
      title: "Customers who trusted us",
      items: [
        { name: "Carlos M.", role: "Miami, FL", text: "My SUV's headliner was completely sagging. Ángel made it look brand new and came to my house. Flawless work." },
        { name: "Jennifer R.", role: "Hialeah, FL", text: "Super professional and detail-oriented. My door panels came out identical to the original. Highly recommended." },
        { name: "David S.", role: "Fort Lauderdale, FL", text: "Fast to quote and right on time. The interior detailing left my car looking and smelling like new." },
        { name: "María G.", role: "Doral, FL", text: "The pillar and sunroof restoration exceeded my expectations. Excellent attention from start to finish." },
      ],
    },
    faq: {
      kicker: "FAQ",
      title: "Answers to your questions",
      items: [
        { q: "Which brands do you work on?", a: "We restore interiors on virtually all makes and models, from daily drivers to high-end vehicles." },
        { q: "How long does the work take?", a: "It depends on the vehicle model: the job takes roughly 2 to 4 hours. The day and time are scheduled subject to availability, coordinated via WhatsApp." },
        { q: "Is there a warranty?", a: "Yes. We offer a 30-day warranty after the repair on our workmanship and materials." },
        { q: "Do I need to leave my vehicle?", a: "In most cases, no. We're a Mobile service and come to you across Miami-Dade and Broward." },
        { q: "How do I request a quote?", a: "Easy: message us on WhatsApp with photos of your vehicle and we'll send a personalized estimate." },
      ],
    },
    academy: {
      badge: "Coming Soon",
      title: "Angel Cars Academy",
      text: "Soon we'll be sharing our expertise through specialized auto upholstery courses for those who want to learn the craft and build their own business.",
      placeholder: "Your email address",
      button: "I want info about the courses",
      success: "Done! We'll let you know when enrollment opens.",
      error: "Please enter a valid email.",
    },
    contact: {
      kicker: "Contact",
      title: "Request your quote today",
      subtitle:
        "We're ready to restore your vehicle's interior. Reach out and get a fast response.",
      location: "Florida, United States",
      areaLabel: "Service area",
      areas: "Miami-Dade County · Broward County",
      emailLabel: "Email",
      phoneLabel: "Phones",
      whatsapp: "WhatsApp",
      call: "Call",
      quote: "Request a Quote",
      whatsappMsg:
        "Hello Angel Cars, I'd like to request a quote to restore my vehicle's interior.",
    },
    footer: {
      tagline:
        "Specialists in vehicle interior restoration with high-quality finishes across Miami-Dade and Broward.",
      quickLinks: "Quick links",
      contact: "Contact",
      follow: "Follow us",
      rights: "All rights reserved.",
    },
  },
};
